import axios from "axios";


const SERVER_URL = window.SOCKET_SERVER_URL; 

const socketAxiosInstance = axios.create({
    baseURL:SERVER_URL
})

export default socketAxiosInstance;